import { getLabelAgenteCarga, isHAWB, isHBL } from "../../../features/house/houseUtils";
import QCXSelectTransportadorInternacionalAutocomplete from "../../../shared-components/select-transportador-internacional/QCXSelectTransportadorInternacionalAutocomplete";


export default function QCXAgenteCargaOrAmadorComponent({
    id,
    key,
    name,
    label,
    disabled,
    type,
}) {

    if(isHAWB(type)) {
        return (
            <QCXSelectTransportadorInternacionalAutocomplete
                id={id}
                key={key}
                name={name}
                label={label}
                disabled={disabled}
            />
        );
    }

    if(isHBL(type)) {
        return (
            <QCXSelectTransportadorInternacionalAutocomplete
                id={id}
                key={key}
                name={name}
                label={label}
                disabled={disabled}
            />
        );
    }

     
}